import { network } from 'services/network';

export const getActivitiesSummary = (params) => {
    const url = `api/bo/getActivitiesSummary?metaDataId=${params}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
